import { email, helpers, minLength, required } from "@vuelidate/validators"
import { isCardNumberValid, isCPFValid, isGratherOrEqualThen, isNameValid, isPhoneValid, isValidCardExpirationDate } from "../validation_functions"
import PaymentService from "@/services/PaymentService"


const cpfValidation = {
    required: helpers.withMessage('Informe um CPF', required),
    isValid: helpers.withMessage('Informe um CPF válido', isCPFValid),
}


export const creditCardValidations = () => {
    return {
        holder_name: {
            required: helpers.withMessage('Informe um nome', required),
            isValid: helpers.withMessage('Informe um nome válido', isNameValid)
        },
        number: {
            required: helpers.withMessage('Informe o número do cartão', required),
            minLength: helpers.withMessage("Informe um número de cartão válido", isCardNumberValid)
        },
        expiration_date: {
            required: helpers.withMessage("Informe uma data de validade", required),
            isValid: helpers.withMessage("Informe uma data de validade válida", isValidCardExpirationDate),
        },
        cvv: {
            required: helpers.withMessage('Informe um cvv', required),
            minLength: helpers.withMessage("Informe um cvv válido", minLength(3))
        },
        document_number: cpfValidation,
    }
}
export const addressValidations = () => {
    return {
        zip_code: { required: helpers.withMessage("Informe o cep", required) },
        street: { required: helpers.withMessage("Informe o endereço", required) },
        number: { required: helpers.withMessage("Informe o número", required) },
        city: { required: helpers.withMessage("Informe a cidade", required) },
        state: { required: helpers.withMessage("Informe o estado", required) },
    }
}

export const loginValidations = () => {
    return {
        phone: {
            required: helpers.withMessage("Informe um celular", required),
            minLength: helpers.withMessage("Informe um celular válido com ddd", isPhoneValid)
        },
    }
}
export const registerValidations = () => {
    return {
        name: {
            required: helpers.withMessage('Informe um nome', required),
            isValid: helpers.withMessage('Informe um nome válido', isNameValid)
        },
        email: {
            required: helpers.withMessage("Informe um email", required),
            email: helpers.withMessage("Informe um email válido", email)
        },
    }
}
export const qrcodeValidations = () => {
    return {
        code: {
            required: helpers.withMessage("Informe um código", required),
        },
    }
}
export const addBalanceValidations = () => {
    const balanceMinValue = PaymentService.BALANCE_MIN_VALUE
    const rules = {
        required: helpers.withMessage("Informe o valor", required),
        minValue: helpers.withMessage(`O valor mínimo é de ${balanceMinValue} reais`, (value: string) => {
            return isGratherOrEqualThen(value, balanceMinValue)
        })
    }
    return {
        // selected_value: rules,
        balance_value: rules,
        document_number: cpfValidation
    }
}